import http from "../config/http-configs";
import {configJson} from "@/api/config/http-configs";


export const getInviteForm = () => {
    return http.get(`/mobile/apply/form/info/INVITE_APPLY`)
}

export const addApply = (apply) => {
    const url = '/mobile/apply/add'
    return http.post(url, apply, configJson)
}

export const cancelApply = (apply) => {
    const url = '/mobile/apply/cancel'
    return http.post(url, apply, configJson)
}

export const cancelApplyByEmployee = (apply) => {
    const url = '/mobile/apply/employee/cancel'
    return http.post(url, apply, configJson)
}

// 员工修改预约（时间/表单），NONE/PROCESS/PASS 且未到访可改
export const updateApplyByEmployee = (apply) => {
    const url = '/mobile/apply/employee/update'
    return http.post(url, apply, configJson)
}

export const approveApply = (apply) => {
    const url = '/mobile/apply/approve'
    return http.post(url, apply, configJson)
}

export const transferApply = (apply) => {
    const url = '/mobile/apply/transfer'
    return http.post(url, apply, configJson)
}

export const getApproves = (applyId) => {
    return http.get(`/mobile/apply/approve/info/${applyId}`)
}

export const getMakeCopies = (applyId) => {
    return http.get(`/mobile/apply/copy/info/${applyId}`)
}

export const getTransfers = (applyId) => {
    return http.get(`/mobile/apply/transfer/info/${applyId}`)
}

export const getAccompanies = (applyId) => {
    return http.get(`/mobile/apply/accompany/info/${applyId}`)
}

//员工
export const getValidPendingApplies = () => {
    return http.get('/mobile/apply/employee/pending/valid')
}

export const getInvalidPendingAppliesByEmployeeId = (pageIndex, pageSize) => {
    let page = {"current": pageIndex, "size": pageSize}
    const url = '/mobile/apply/employee/pending/invalid'
    return http.post(url, page, configJson)
}

export const getValidFinishApplies = () => {
    return http.get('/mobile/apply/employee/finish/valid')
}

export const getInvalidFinishAppliesByEmployeeId = (pageIndex, pageSize) => {
    let page = {"current": pageIndex, "size": pageSize}
    const url = '/mobile/apply/employee/finish/invalid'
    return http.post(url, page, configJson)
}
